import React from "react";
import { connect } from "react-redux";
import { Link } from "@material-ui/core";
// todo: do something with this, should it be here, is it useful, could it be useful?
window.addEventListener("unhandledrejection", function (event) {
    // the event object has two special properties:
    // alert(event.promise); // [object Promise] - the promise that generated the error
    // alert(event.reason); // Error: Whoops! - the unhandled error object
    console.log("UNHANDLED ERROR", event);
});
class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasUnhandledError: false };
    }
    static getDerivedStateFromError(error) {
        // Update state so the next render will show the fallback UI.
        return { hasError: true };
    }
    componentDidCatch(error, errorInfo) {
        console.log("ERROR", error, errorInfo);
    }
    render() {
        if (this.state.hasUnhandledError) {
            return React.createElement("h1", null, "Something went wrong.");
        }
        if (this.props.error) {
            console.log("ERROR", this.props.error);
            return (React.createElement("div", null,
                React.createElement("h1", null, "Something went wrong in complaints"),
                React.createElement("p", null,
                    React.createElement(Link, { href: "javascript:window.location.href=window.location.href" }, "Click to reload and try again"))));
        }
        return this.props.children;
    }
}
const connector = connect((state) => ({
    error: state.errors.error,
}));
export default connector(ErrorBoundary);
